module.exports = __webpack_public_path__ + "static/media/exukonline_tail_light.e6829698.jpg";